import { useNavigate } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import LanguageModal from "@/components/feature/LanguageModal";
import { useEffect } from "react";

function RouteRestorer() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const route = params.get("r");
    if (!route) return;

    const basePath = __BASE_PATH__ || "/";
    let targetRoute = decodeURIComponent(route);

    // Strip base path if present at the start (for Readdy preview URLs)
    if (basePath !== "/" && targetRoute.startsWith(basePath)) {
      targetRoute = targetRoute.slice(basePath.length) || "/";
    }

    // Remove the ?r parameter from the URL without triggering navigation
    const url = new URL(window.location.href);
    url.searchParams.delete("r");
    window.history.replaceState(null, "", url.toString());

    // Navigate React Router to the restored route
    navigate(targetRoute, { replace: true });
  }, [navigate]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <RouteRestorer />
        <LanguageModal />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;